import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import LoadingProjectData from './LoadingProjectData';
import ProjectLabelsAndCadence from './ProjectLabelsAndCadence';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const ComingSoonWrapper = styled(Text)`
  background-color: ${getColor('melrose')};
  padding: 0.3rem 0.5rem;
  width: fit-content;
  color: white;
  border-radius: 4px;
`;

const ProjectColumn = ({
  project,
  lastIteration,
  isLoading,
  projectState,
  isNewProjectLoading,
  showFavoritesIcon,
  addProjectToFavorites,
  removeProjectFromFavorites,
  isFavoriteProject
}) => {
  const { name } = project;

  const projectName = (
    <div className='flex flex-row gap-2 items-center'>
      <Text size='large' data-testid='project-name'>
        {name}
      </Text>

      <span className='h-10 flex flex-col items-center justify-center'>
        {showFavoritesIcon && (
          <LBButton
            variant='ghost'
            size='icon'
            data-testid='star-icon'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              isFavoriteProject(project)
                ? removeProjectFromFavorites(project)
                : addProjectToFavorites(project);
            }}
          >
            <Icon
              color='dodgerBlue'
              name={isFavoriteProject(project) ? 'star' : 'outlinedstar'}
            />
          </LBButton>
        )}
      </span>
    </div>
  );

  const projectData = (
    <>
      {isLoading && <LoadingProjectData projectState={projectState} />}
      <div className='flex flex-col gap-2'>
        {projectName}
        <ProjectLabelsAndCadence
          project={project}
          lastIteration={lastIteration}
        />
      </div>
    </>
  );
  const projectComingSoon = (
    <>
      <ComingSoonWrapper mb='0.4rem' data-testid='project-coming-soon'>
        Coming soon
      </ComingSoonWrapper>
      {projectName}
    </>
  );
  const projectsDataWrapper = (
    <Flex direction='column' pt='normal' pb='normal' pr='normal' pl='small'>
      {isNewProjectLoading ? projectComingSoon : projectData}
    </Flex>
  );

  return projectsDataWrapper;
};

export default ProjectColumn;
